export default {"src":"/_next/static/media/trademark.cb32cfde.svg","height":50,"width":85,"blurWidth":0,"blurHeight":0};